import { createI18n } from 'vue-i18n'
import { nextTick } from 'vue'
//TODO: 在对应英文词条下库后，使用插件@intlify/unplugin-vue-i18n导入，可以帮助检查词条完整性
import zhCN from '@/locales/zh-CN/zh-CN.json'

export enum SupportLocales {
  zhCN = 'zh-CN',
}

const isSupportLocale = (locale: string): locale is SupportLocales => locale in SupportLocales

function getLanguage() {
  // 获取语言并转换成zh-CN格式
  const bsLang = (
    window.sessionStorage.getItem('ocloud_lang') ||
    (window.locate as unknown as string) ||
    navigator.language
  ).replace(/[-|_].*/, ($1) => $1.toUpperCase())

  return bsLang
}
const locale = getLanguage()

export const i18n = createI18n({
  legacy: false,
  // locale: isSupportLocale(locale) ? locale : SupportLocales.zhCN,
  locale: SupportLocales.zhCN,
  fallbackLocale: SupportLocales.zhCN,
  messages: {
    'zh-CN': zhCN,
  },
  globalInjection: true,
  missingWarn: false,
  fallbackWarn: false,
})

export function setI18nLanguage(locale: SupportLocales) {
  i18n.global.locale.value = locale
  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  // document.querySelector('html').setAttribute('lang', locale)
}

/**
 * 用于语言选项增多之后的懒加载
 *
 * @param i18n
 * @param locale
 * @returns Promise
 */
export async function loadLocaleMessages(locale: SupportLocales) {
  // load locale messages with dynamic import
  const messages = await import(`./locales/${locale}.json`)

  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages.default)

  return nextTick()
}
